import util from '@/tools/commonUtil'

export default {
  orderById: 224,
  elementType: 'SatisfactionBox',
  baseElementType: 'SATISFACTION',
  elementDesc: '满意度题',
  type: 'satisfactionbox',
  // 是否可配置
  config: true,
  title: '满意度题',
  placeholder: '',
  tipsEvaluate: '写评价',
  tipsEvaluateInput: '说说你的评价',
  visibility: '0',
  toolbar: {
    config: false
  },
  paramInt01: '3',
  optionList: [],
  tmpValue: 0,
  value: null,
  ruleError: '该字段不能为空',
  optionList: [],
  selectedTags: [], // 选中的标签
  useTagInput: 0, // 使用评价文本框
  otherTag: '', // 自定义标签内容
  otherAnswer: {
    tags: [],
    otherTag: ''
  },
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {icon: ''})
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/SatisfactionBox/config.js